import { useEffect } from 'react';

/**
 * Hook that alerts clicks outside of the passed ref
 */
const useOutsideClick = (
  ref,
  onOutsideClick,
  allowClick,
  { shouldAddHandler = true, dependencies = [], eventType = 'click' } = {},
) => {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) onOutsideClick && onOutsideClick();
    };

    // Bind the event listener
    // If allowClick === true, set useCapture to true, else set to false
    if (shouldAddHandler) {
      document.addEventListener(eventType || 'click', handleClickOutside, allowClick);
    } else {
      document.removeEventListener(eventType || 'click', handleClickOutside, allowClick);
    }

    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener(eventType || 'click', handleClickOutside, allowClick);
    };
  }, [ref, shouldAddHandler, ...(dependencies ?? []), eventType]);
};

export default useOutsideClick;
